import React from 'react';
import { Chip } from '@mui/material';

const statusColors = {
  // Case statuses
  'Submitted': { bg: '#E3F2FD', color: '#1565C0' },
  'In Review': { bg: '#FFF3E0', color: '#E65100' },
  'Pending Document': { bg: '#FFF8E1', color: '#F57F17' },
  'Pending Bank Decision': { bg: '#F3E5F5', color: '#7B1FA2' },
  'Approved': { bg: '#E8F5E9', color: '#2E7D32' },
  'Rejected': { bg: '#FFEBEE', color: '#C62828' },
  'Disbursed': { bg: '#E0F2F1', color: '#00695C' },
  'Closed': { bg: '#ECEFF1', color: '#546E7A' },
  // General statuses
  'Active': { bg: '#E8F5E9', color: '#2E7D32' },
  'Inactive': { bg: '#ECEFF1', color: '#546E7A' },
  'Pending': { bg: '#FFF8E1', color: '#F57F17' },
  'Pending Approval': { bg: '#FFF3E0', color: '#E65100' },
  'Expired': { bg: '#FFEBEE', color: '#C62828' },
  // Commission statuses
  'Paid': { bg: '#E8F5E9', color: '#2E7D32' },
  'Pending Payout': { bg: '#FFF8E1', color: '#F57F17' },
  'Processing': { bg: '#E3F2FD', color: '#1565C0' },
  // Referral levels
  'Silver': { bg: '#ECEFF1', color: '#546E7A' },
  'Gold': { bg: '#FFF8E1', color: '#F57F17' },
  'Platinum': { bg: '#EDE7F6', color: '#4527A0' },
};

const defaultColor = { bg: '#ECEFF1', color: '#546E7A' };

export default function StatusBadge({ status, size = 'small' }) {
  const { bg, color } = statusColors[status] || defaultColor;
  return (
    <Chip
      label={status}
      size={size}
      sx={{
        backgroundColor: bg,
        color: color,
        fontWeight: 600,
        fontSize: size === 'small' ? '0.75rem' : '0.85rem',
        borderRadius: '6px',
      }}
    />
  );
}
